import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.querySelectorAll('.js-aid-logos-slider'));

  containers.forEach((container) => {
    const wrapper = container.querySelector('.js-aid-logos-slider-wrapper');

    if (wrapper) {
      const slider = new Swiper(wrapper, {
        slidesPerView: 4,
        spaceBetween: 1,
        breakpoints: {
          0: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
        },
      });

      slider.init();
    }
  });
});
